import {
  Component, inject, Input, OnChanges, OnInit,
  signal,
} from '@angular/core';
import { NavigationEnd, Router, RouterLinkActive, RouterLink } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { NavItem } from './navItem';
import { User } from '../../models/user';
import { AuthService } from '../../services/auth.service';
import { NAV_ITEM_SERVICE } from '../../services/navitem.service.interface';
import { NgClass } from '@angular/common';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-default-menu',
    templateUrl: './default-menu.component.html',
    styleUrls: ['./default-menu.component.scss'],
    imports: [NgClass, RouterLinkActive, RouterLink, TranslatePipe ],
})
export class DefaultMenuComponent implements OnInit, OnChanges {
  @Input()
    mobileExpanded = false;

  @Input()
    collapsed = false;

  navItems = signal<NavItem[]>([]);

  user?: User;

  private authService = inject(AuthService);
  private router = inject(Router);
  private navService = inject(NAV_ITEM_SERVICE);
  private translateService = inject(TranslateService);

  ngOnInit() {
    firstValueFrom(this.navService.getSidebarNavItems()).then((items) => {
      this.navItems.set(items);
      this.checkActiveItem();
      this.navItems().forEach((item) => {
        item.setExpanded(item.active || item.isChildActive());
      });
    });
    this.authService.getCurrentUser().subscribe((user) => {
      if (user) {
        this.user = user;
      }
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.checkActiveItem();
        this.navItems().forEach((item) => {
          if (!item.expanded) {
            item.setExpanded(item.isChildActive());
          }
        });
      }
    });
  }

  ngOnChanges() {
    this.checkActiveItem();
  }

  checkActiveItem() {
    // Get first part of the url and set active item
    const url = this.router.url.split('?')[0].substring(1).split('/')[0];
    if (url) {
      const path = url;
      this.navItems().forEach((item) => {
        item.setActive(path);
      });
    }
  }

  translate(key: string): string {
    return this.translateService.instant(key);
  }

  navigate(url: string) {
    if (this.router.url.split('?')[0].substring(1) !== url) {
      this.router.navigate([url]);
    }
  }
}
